import React, { useEffect, useCallback, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'components/Button';
import ModalHeader from 'components/ModalHeader';
import api from 'services/api';
import { FaCamera } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Input from 'components/Input';
import Select from 'components/ReactSelect';
import { transformToSelect } from 'utils/toSelect';
import { Container, Content } from './styles';

interface SportProps {
  id: string;
  id_type: string;
  name: string;
  photo: string;
  photo_url: string;
  created_at: Date;
  updated_at: Date;
}
interface LastStepProps {
  name: string;
}
interface SelectProps {
  value: string;
  label: string;
}
interface PageProps {
  closeModal: () => void;
  sport: SportProps;
}
const schema = yup.object().shape({
  name: yup.string().required(),
});

const EditSportModal: React.FC<PageProps> = ({ closeModal, sport }) => {
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [selectedSports, setSelectedSports] = useState<SelectProps>();
  const [options, setOptions] = React.useState([] as SelectProps[]);
  const { register, handleSubmit, setValue, control, errors } =
    useForm<LastStepProps>({
      resolver: yupResolver(schema),
    });
  const getTypeSports = useCallback(() => {
    api.get('/courts/findAllCourtTypes').then((response) => {
      const types = transformToSelect([...response.data]);
      setOptions(types);
      const optionSelected = types.filter(
        (item: SelectProps) => item.value === sport.id_type
      );
      setSelectedSports(optionSelected);
    });
  }, [sport.id_type]);
  useEffect(() => {
    getTypeSports();
    setValue('name', sport.name);
  }, [setValue, sport.name, getTypeSports]);

  const onSubmit = useCallback(
    ({ name }: LastStepProps) => {
      setLoading(true);
      const data = {
        id_sport: sport.id,
        name_sport: name,
      };
      api.put('/sports/updateSport', data).then(() => {
        toast.success('Esporte atualizado com sucesso!');
        setLoading(false);
        closeModal();
      });
    },
    [closeModal, sport.id]
  );
  const handleSelectTypeSport = (selectedOption: any) => {
    setSelectedSports(selectedOption);
  };

  const handleUploadPhoto = useCallback(
    (event: any) => {
      setImageLoading(true);
      setSelectedImage(event);
      const dataFile = new FormData();
      dataFile.append('photo', event);
      api.patch(`/sports/photo?id=${sport.id}`, dataFile).then(() => {
        setImageLoading(false);
      });
    },
    [sport]
  );

  return (
    <Container>
      <ModalHeader title="Editar Esporte" closeModal={closeModal} />
      <Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sectionFields">
            <aside className="photoContainer">
              <input
                className="photoInput"
                type="file"
                name="myImage"
                onChange={(event: any) => {
                  handleUploadPhoto(event?.target?.files[0]);
                }}
              />
              {selectedImage ? (
                <img src={URL.createObjectURL(selectedImage)} alt="" />
              ) : (
                <>
                  {sport.photo === '' ? (
                    <FaCamera size={64} color="#000" />
                  ) : (
                    <img src={sport.photo} alt="" />
                  )}
                </>
              )}
            </aside>
            <Input
              title="Nome"
              name="name"
              register={register}
              error={!!errors.name?.message}
            />
            <Select
              label="Tipo da quadra"
              onChange={handleSelectTypeSport}
              className="select"
              closeMenuOnSelect
              value={selectedSports}
              options={options}
            />
          </div>
          <Button type="submit">{loading ? 'Aguarde...' : 'Salvar'}</Button>
        </form>
      </Content>
    </Container>
  );
};

export default EditSportModal;
